import ReportsDetailsRepositoryImpl from './impl/ReportsDetailsRepositoryImpl'

export default {
  getInstance () {
    return new ReportsDetailsRepositoryImpl()
  }
}
